import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '@components/Sprite'
import * as styles from '~/styles/components/reciteMe.module.scss'

class ReciteMe extends Component {
  loadRecitme () {
    if (typeof window !== 'undefined') {
      window.loadService()
    }
  }

  render () {
    return (
      <button
        type="button"
        className={classNames(styles.button)}
        onClick={() => this.loadRecitme()}
        aria-label={this.props.title}
      >
        <span className={classNames(styles.icon, 'icon')}>
          <Sprite name="accessibility" fill={true} />
        </span>

        {this.props.title}
      </button>
    )
  }
}

ReciteMe.propTypes = {
  title: PropTypes.string
}

export default ReciteMe
